(function ($) {
  const customAccordions = document.querySelectorAll('.faq-qa-row .question-line');

  if (!customAccordions.length) {
    return;
  }

  $(customAccordions).each(function () {
    $(this).click(function () {
      $(this).next().slideToggle(250);
      $(this).find('.faq-btn').toggleClass('opened');
    });
  });
})(jQuery);
